import BaseService from '_services/rest/base';

class PdfService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}`;
  }

  convertPdfToCmyk(pdfBlob) {
    const formData = new FormData();
    formData.append('pdf', pdfBlob, 'documento.pdf');

    return this.request(`${this.getUrl()}convert-pdf-cmyk`, formData, 'post', 'blob', {
      Accept: 'application/pdf',
    })
      .then(response => {
        const pdfBlobConverted = response;
        const convertedPdfUrl = URL.createObjectURL(pdfBlobConverted);
        window.open(convertedPdfUrl, '_blank');
      }).catch(error => {
        console.error(error);
      });
  }
}

export default new PdfService();
